module.exports = __webpack_public_path__ + "img/mail.18ce3376.svg";